import ThemeButton from "@theme/ui-components/buttons/ThemeButton";
import { OrderProductModel } from "../../../../services/order_products/models/order_product.model";
import { useCallback, useState } from "react";
import * as signalR from "@microsoft/signalr";

import { useSelector } from "react-redux";
import { getCompanyId } from "../../../../react-reduxs/slices/auth/auth_slice";
import { OrderHubUrl } from "../../../../consts/api";
import { OrderModel } from "../../../../services/orders/models/order.model";
import { OrderProductStatusEnum } from "../../../../enums/orders/order_status.enum";
import { OrderProductStatusModel } from "../../../../services/order_product_statuses/models/order_product_status.model";

interface Template4CancelOrderButtonProps {
  order: OrderModel | undefined;
  orderProduct: OrderProductModel;
  orderProductStatusList: OrderProductStatusModel[];
}

export const Template4CancelOrderButton: React.FC<
  Template4CancelOrderButtonProps
> = ({ order, orderProduct, orderProductStatusList }) => {
  const companyId = useSelector(getCompanyId);
  const [loading, setLoading] = useState(false);
  // ─── Ürün durum güncelleme (SignalR) ─────────────────────────────────────────
  const updateOrderProductStatus = useCallback(
    async (
      tableId: string,
      orderProductId: string,
      orderProductStatusId: number,
    ) => {
      const connection = new signalR.HubConnectionBuilder()
        .withUrl(OrderHubUrl(companyId).url)
        .withAutomaticReconnect()
        .build();
      try {
        await connection.start();
        setLoading(true);
        await connection.invoke(
          "OrderProductStatusUpdate",
          companyId,
          tableId,
          orderProductId,
          orderProductStatusId,
        );
      } catch (err) {
        console.error(err);
      } finally {
        connection.stop();
        setLoading(false);
      }
    },
    [companyId],
  );
  return (
    <>
      {(orderProductStatusList.find(
        (x) => x.name === OrderProductStatusEnum.cancelled,
      )?.id || 0) === 0 ? (
        <></>
      ) : (
        <ThemeButton
          loading={loading}
          onClick={() => {
            updateOrderProductStatus(
              order?.tableId || "",
              orderProduct.id,
              orderProductStatusList.find(
                (x) => x.name === OrderProductStatusEnum.cancelled,
              )?.id || 0,
            );
          }}
          rounded
          icon="fa fa-trash"
          iconPos="left"
          size="small"
          style={{
            padding: 0,
            height: "30px",
            width: "30px",
            fontSize: "10px",
            color: "#d35d5d",
          }}
          severity="danger"
        />
      )}
    </>
  );
};
